import InputField from "../../../components/InputField";

export default function DestinatarStep({ data, errors, update }) {
  return (
    <div style={{ display: "flex", flexWrap: "wrap", gap: "16px" }}>
      <InputField label="Nume complet" value={data.destinatarNume} onChange={update("destinatarNume")} placeholder="ex: Ionescu Maria" required error={errors.destinatarNume} />
      <InputField label="Adresa" value={data.destinatarAdresa} onChange={update("destinatarAdresa")} placeholder="ex: Str. Exemplu nr. 2, Bucuresti" required error={errors.destinatarAdresa} />
    </div>
  );
}
